/* istanbul ignore file */
import { connect } from 'react-redux';
import CardTypeConfigView from './CardTypeConfigView';
import { getCardTypeListing } from '../actions/CardTypeConfigActions';

const mapStateToProps = (state, ownProps) => {
    const { cardTypeConfig } = state.cardTypeConfig;
    
    return {
        cardTypeConfig,
        store: ownProps.store
    };
}

const mapDispatchToProps =  {
    getCardTypeListing
}

export default connect(mapStateToProps, mapDispatchToProps)(CardTypeConfigView);